import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import { ROUTE } from '../../middleware/route';
import { validate } from '../../middleware/validator';
import { isValidDate } from '../signup/actionvalidators';
import paths from '../../../routes/paths';
import { CLEAR_NEW_ORDER_FLOW } from '../neworder';

const validateDateString = dateStr => {
  const dt = new Date(dateStr);
  if (!isValidDate(dt.getFullYear(), dt.getMonth() + 1, dt.getDate())) { return false; }
  if (dt.getTime() < Date.now()) return false;
  return true;
};

// ACTIONS
export const UPDATE_CALENDAR_DATE = 'SCHEDULING/UPDATE_CALENDAR_DATE';
export const UPDATE_SELECTED_DATE = 'SCHEDULING/UPDATE_SELECTED_DATE';
export const SET_ERROR_MESSAGE = 'SCHEDULING/SET_ERROR_MESSAGE';
export const CLEAR_ERROR_MESSAGE = 'SCHEDULING/CLEAR_ERROR_MESSAGE';

// ACTION CREATORS
export const setCalendarDisplayDate = newDate => ({
  type: UPDATE_CALENDAR_DATE,
  newDate,
});

export const setSelectedOrderDate = (selectedDate, fromHomeReorder) => ({
  [validate]: {
    validator: () => validateDateString(selectedDate),
    success: {
      type: UPDATE_SELECTED_DATE,
      selectedDate,
      [ROUTE]: fromHomeReorder ? paths.createOrder.basket : paths.createOrder.addMedicine,
    },
    fail: { type: SET_ERROR_MESSAGE },
  },
});

export const setErrorMessage = () => ({
  type: SET_ERROR_MESSAGE,
});

export const clearErrorMessage = () => ({
  type: CLEAR_ERROR_MESSAGE,
});

// SELECTORS
export const getDisplayDate = state => state.displayDate;
export const getSelectedOrderDate = state => state.selectedDate;
export const getErrorMessage = state => state.errorMessage;

// REDUCERS
export const displayDate = handleActions(
  {
    [UPDATE_CALENDAR_DATE]: (state, action) => action.newDate,
  },
  null,
);

export const selectedDate = handleActions(
  {
    [UPDATE_SELECTED_DATE]: (state, action) => action.selectedDate,
    [UPDATE_CALENDAR_DATE]: () => null,
    [CLEAR_NEW_ORDER_FLOW]: () => null,
  },
  null,
);

export const errorMessage = handleActions(
  {
    [SET_ERROR_MESSAGE]: () => 'You must enter a valid date for your order.',
    [CLEAR_ERROR_MESSAGE]: () => null,
  },
  null,
);

export default combineReducers({
  displayDate,
  selectedDate,
  errorMessage,
});
